function initVariantImageSwitcher(card) {
  var variantItems = card.querySelectorAll('.variant-selects li');
  variantItems.forEach(function (item) {
    item.addEventListener('click', function () {
      // remove "selected" class from all variants in this card
      variantItems.forEach(v => v.classList.remove('selected'));
      item.classList.add('selected');

      // get data-img (relative path from swatch)
      var newImgUrl = item.getAttribute('data-img');
      if (!newImgUrl) return;

      var mainImage = card.querySelector('.card__media img');
      var pictureElement = card.querySelector('.card__media picture');
      var sourceElements = pictureElement ? pictureElement.querySelectorAll('source') : [];

      // add loader
      var loader = document.createElement('div');
      loader.className = 'image-loader';
      card.querySelector('.card__media').appendChild(loader);

      // build base + responsive sizes
      var newImageBase = `//www.thedressoutlet.com/cdn/shop/${newImgUrl}`;
      var newImageSrc = `${newImageBase}?width=533`;
      var newImageSrcset = `
        ${newImageBase}?width=165 165w,
        ${newImageBase}?width=360 360w,
        ${newImageBase}?width=533 533w,
        ${newImageBase}?width=720 720w,
        ${newImageBase}?width=940 940w,
        ${newImageBase}?width=1066 1066w
      `;

      // preload image
      var img = new Image();
      img.src = newImageSrc;
      img.srcset = newImageSrcset;

      img.onload = function () {
        // update <img>
        if (mainImage) {
          mainImage.src = newImageSrc;
          mainImage.srcset = newImageSrcset;
        }

        // update <source> tags (for responsive images)
        sourceElements.forEach(source => {
          var media = source.getAttribute('media');
          switch (media) {
            case '(min-width: 1066px)':
              source.srcset = `${newImageBase}?width=1066`;
              break;
            case '(min-width: 940px)':
              source.srcset = `${newImageBase}?width=940`;
              break;
            case '(min-width: 720px)':
              source.srcset = `${newImageBase}?width=720`;
              break;
            case '(min-width: 533px)':
              source.srcset = `${newImageBase}?width=533`;
              break;
            case '(min-width: 360px)':
              source.srcset = `${newImageBase}?width=360`;
              break;
          }
        });

        loader.remove();
      };

      img.onerror = function () {
        loader.remove();
      };
    });
  });
}


let checkCards = setInterval(() => {
  const cards = document.querySelectorAll('.related-products .product-card-wrapper');
  if (cards.length > 0) {
    clearInterval(checkCards); // stop checking
    cards.forEach(card => {
      if (!card.dataset.init) {
        initVariantImageSwitcher(card);
        card.dataset.init = "true"; // prevent duplicate binding
      }
    });
  }
}, 1000);

document.addEventListener('click', function(event) {
  const anchor = event.target.closest('.number-showmore');
  if (!anchor) return; // Only proceed if a .number-showmore was clicked
  event.preventDefault();
  const fieldset = anchor.closest('fieldset');
  if (fieldset) {
    fieldset.classList.toggle('show_more');
  }
});
